export enum TaxIncentivesEligibility {
  All = 0,
  Yes = 1,
  No = 2,
}
